





















import { Component, Vue, Watch } from 'vue-property-decorator';
import FilterOption from '@/models/FilterOption';
import { FilterGetter } from '@/store/getters';
import { FilterAction } from '@/store/actions';
import HelperService from '@/services/HelperService';

@Component({
  name: 'filter-chips-component',
})
export default class FilterChipsComponent extends Vue {
  private filterOptions: Array<FilterOption> = [];

  private helperService = HelperService;

  private get allFilterOptions(): Array<FilterOption> {
    return this.filterOptions;
  }

  private get appliedFilterOptions(): Map<string, FilterOption> {
    return this.$store.getters[FilterGetter.AppliedFilterOptions];
  }

  @Watch('appliedFilterOptions')
  private updateLocalFilterOptions(newValue: Map<string, FilterOption>) {
    this.filterOptions = [...newValue.values()];
  }

  private handleChipClick(filterOption: FilterOption) {
    this.$store.dispatch(FilterAction.ToggleFilterOption, { filterOption });
  }

  private handleClearAllClick() {
    if (this.appliedFilterOptions.size > 0) {
      this.$store.dispatch(FilterAction.RemoveAllAppliedFilterOptions);
    }
  }

  private translatedFilter(filterOption: FilterOption) {
    return this.helperService.translatedFilterOption(filterOption);
  }
}
